import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '', // Empty for relative proxy
    withCredentials: true,
});

// Add a request interceptor to attach the token
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;
